<template>
  <div class="loading-wrap">
    <div class="box">
      <div :class=" rotate > 50 && rotate <= 100 ? 'auto' : ''" class="clip">
        <div :style="`transform: rotate(${3.6 * rotate}deg)`" class="left" />
        <div :style="`transform: rotate(${3.6 * rotate}deg)`" class="point" />
        <div :class=" rotate > 100 || rotate < 50 ? 'width-none' : ''" class="right" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loading',
  props: {
    rotate: {
      type: Number,
      default: 0,
    },
  },
}
</script>

<style scoped lang="scss">
.loading-wrap {
  position: relative;
  // left: 250px;
  // top: 250px;
  width: 107px;
  height: 107px;
  // background: rgba(0,0,0,.8);
  border-radius: 50%;
  box-shadow: inset 0 0 0 2px rgba(0, 0, 0, 0.1);
}
.box {
  box-sizing: border-box;
  position: relative;
  left: 0px;
  top: 0px;
  width: 107px;
  height: 107px;
  // background-color: #fdf9f6;
  border-radius: 50%;
}

.clip {
  box-sizing: border-box;
  width: 107px;
  height: 107px;
  position: absolute;
  // border: 5px solid #fdf9f6;
  border: 5px solid transparent;
  border-radius: 50%;
  clip: rect(0, 107px, 107px, 53px);
}
.left {
  box-sizing: border-box;
  width: 107px;
  height: 107px;
  position: absolute;
  border: 5px solid #f4c000;
  border-radius: 50%;
  clip: rect(0 53px 107px 0);
  top: -5px;
  left: -5px;
}
.point {
  position: absolute;
  top: -5px;
  left: -5px;
  width: 107px;
  height: 107px;
  &::after {
    content: '';
    position: absolute;
    left: 51px;
    top: 0px;
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: #000;
    background: #f4c000;
  }
}
.right {
  box-sizing: border-box;
  width: 107px;
  height: 107px;
  position: absolute;
  border: 5px solid #f4c000;
  border-radius: 50%;
  clip: rect(0 107px 107px 53px);
  top: -5px;
  left: -5px;
}
.width-none {
  width: 0;
}
.auto {
  clip: auto;
}
</style>
